import { render, staticRenderFns } from "./SendSwap.vue?vue&type=template&id=24e47777&scoped=true"
import script from "./SendSwap.vue?vue&type=script&lang=js"
export * from "./SendSwap.vue?vue&type=script&lang=js"
import style0 from "./SendSwap.vue?vue&type=style&index=0&id=24e47777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e47777",
  null
  
)

export default component.exports